import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '*', redirect: '/'
  }, {
    path: '/', name: 'PageView', component: resolve => require(['@/view/PageView'], resolve), children: [{
      path: '/', redirect: '/home'
    }, {
      path: '/home', name: 'home', component: resolve => require(['@/view/HomePage'], resolve),
    }, {
      path: '/production', name: 'production', component: resolve => require(['@/view/Production'], resolve),
    }, {
      path: '/production/JEZ01', name: 'JEZ01', component: resolve => require(['@/view/Production_JEZ01'], resolve),
    }, {
      path: '/production/JHZ01', name: 'JHZ01', component: resolve => require(['@/view/Production_JHZ01'], resolve),
    }, {
      path: '/production/FB', name: 'FB', component: resolve => require(['@/view/Production_FB'], resolve),
    }, {
      path: '/production/RLS', name: 'RLS', component: resolve => require(['@/view/Production_RLS'], resolve),
    }, {
      path: '/production/SVR', name: 'SVR', component: resolve => require(['@/view/Production_SVR'], resolve),
    }, {
      path: '/production/LS25', name: 'LS25', component: resolve => require(['@/view/Production_LS25'], resolve),
    }, {
      path: '/production/DKT', name: 'DKT', component: resolve => require(['@/view/Production_DKT'], resolve),
    }, {
      path: '/production/YXQ', name: 'YXQ', component: resolve => require(['@/view/Production_YXQ'], resolve),
    }, {
      path: '/production/LDK', name: 'LDK', component: resolve => require(['@/view/Production_LDK'], resolve),
    }, {
      path: '/cases', name: 'cases', component: resolve => require(['@/view/Cases'], resolve),
    }, {
      path: '/download', name: 'download', component: resolve => require(['@/view/Download'], resolve),
    }, {
      path: '/companyintroduction',
      name: 'companyintroduction',
      component: resolve => require(['@/view/CompanyIntroduction'], resolve),
    }, {
      path: '/jobchance', name: 'jobchance', component: resolve => require(['@/view/JobChance'], resolve),
    }, {
      path: '/contactus', name: 'contactus', component: resolve => require(['@/view/ContactUs'], resolve),
    }, {
      path: '/servicedetail', name: 'servicedetail', component: resolve => require(['@/view/ServiceDetail'], resolve),
    }]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js